import glamorous from 'glamorous';

export const AssociationContainer = glamorous.div({
  color: '#5d5d5d',
  '& p': {
    fontSize: '1.4rem',
  },
});



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/AssociationForm/styles.js